module.exports = __webpack_public_path__ + "static/media/400031_02.8b57df21.png";